import { useCallback, useRef } from '@max/max';
/**
 * 防抖 Hook
 * @param fn 需要防抖的函数
 * @param delay 防抖延迟时间（毫秒）
 * @returns 防抖处理后的函数
 */
export function useDebounce(fn, delay = 300) {
    // 使用 useRef 存储定时器 ID
    const timerRef = useRef(null);
    // 返回防抖处理后的函数
    return useCallback((...args) => {
        // 如果已有定时器，则清除
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        // 设置新的定时器
        timerRef.current = setTimeout(() => {
            fn(...args);
            timerRef.current = null;
        }, delay);
    }, [fn, delay]);
}
